// Debug utility to help troubleshoot authentication issues
export const debugAuthToken = () => {
    const token = localStorage.getItem('token');

    if (!token) {
        // ...existing code...
        return null;
    }

    try {
        // Decode JWT token (without verification)
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const payload = JSON.parse(jsonPayload);

        // ...existing code...

        return payload;
    } catch (error) {
        // console.error('🔍 Debug: Error decoding token:', error);
        return null;
    }
};

export const debugApiCall = async (url: string, token?: string) => {
    const authToken = token || localStorage.getItem('token');

    // ...existing code...
    //     url,
    //     hasToken: !!authToken,
    //     tokenLength: authToken?.length || 0
    // });

    if (authToken) {
        debugAuthToken();
        // ...existing code...
    }
};

// Add to window for easy debugging in browser console
if (typeof window !== 'undefined') {
    (window as any).debugAuth = {
        debugAuthToken,
        debugApiCall
    };
}
